module.exports = __webpack_public_path__ + "static/media/secure-donations-buttons.9db0c69a.png";